/**
 *
 * carbon-angular v0.0.0 | carbon-components-angular-progress-bar.js
 *
 * Copyright 2014, 2023 IBM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0

 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, HostBinding, Input, TemplateRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from 'carbon-components-angular/icon';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'carbon-components-angular/icon';

function ProgressBar_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.label);
} }
function ProgressBar_div_0_3_ng_template_0_Template(rf, ctx) { }
function ProgressBar_div_0_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ProgressBar_div_0_3_ng_template_0_Template, 0, 0, "ng-template", 9);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.label);
} }
function ProgressBar_div_0__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "svg", 10);
} }
function ProgressBar_div_0__svg_svg_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "svg", 11);
} }
function ProgressBar_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
    ɵngcc0.ɵɵtemplate(2, ProgressBar_div_0_ng_container_2_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(3, ProgressBar_div_0_3_Template, 1, 1, null, 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, ProgressBar_div_0__svg_svg_4_Template, 1, 0, "svg", 7);
    ɵngcc0.ɵɵtemplate(5, ProgressBar_div_0__svg_svg_5_Template, 1, 0, "svg", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isTemplate(ctx_r0.label));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isTemplate(ctx_r0.label));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isFinished);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isError);
} }
function ProgressBar_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.helperText);
} }
function ProgressBar_div_3_2_ng_template_0_Template(rf, ctx) { }
function ProgressBar_div_3_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ProgressBar_div_3_2_ng_template_0_Template, 0, 0, "ng-template", 9);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.helperText);
} }
function ProgressBar_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtemplate(1, ProgressBar_div_3_ng_container_1_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(2, ProgressBar_div_3_2_Template, 1, 1, null, 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r1.helperId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.isTemplate(ctx_r1.helperText));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isTemplate(ctx_r1.helperText));
} }
const _c0 = function (a0) { return { "transform": a0 }; };
class ProgressBar {
    constructor() {
        this.id = `progress-bar-${ProgressBar.progressBarCounter++}`;
        this.helperId = `progress-bar-helper-${ProgressBar.progressBarCounter}`;
        /**
         * Maximum value
         */
        this.max = 100;
        /**
         * Alignment variant of the progress bar, default is `default`
         */
        this.type = "default";
        /**
         * Current status of the progress bar, default is `active`
         */
        this.status = "active";
        /**
         * Size of the progress bar, default is `big`
         */
        this.size = "big";
        this.defaultClass = true;
        this._value = undefined;
    }
    /**
     * Current value
     */
    set value(num) {
        this._value = num;
        // Validate number
        if (num > this.max) {
            this._value = this.max;
        }
        if (num < 0) {
            this._value = 0;
        }
        // Set values based on current state
        if (this.isError) {
            this._value = 0;
        }
        else if (this.isFinished) {
            this._value = this.max;
        }
    }
    get value() {
        return this._value;
    }
    get percentage() {
        return `scaleX(${this.value / this.max})`;
    }
    // Size
    get bigBar() {
        return this.size === "big";
    }
    get smallBar() {
        return this.size === "small";
    }
    // Type
    get defaultType() {
        return this.type === "default";
    }
    get indentedType() {
        return this.type === "indented";
    }
    get inlineType() {
        return this.type === "inline";
    }
    // Status
    get isFinished() {
        return this.status === "finished";
    }
    get isError() {
        return this.status === "error";
    }
    get indeterminate() {
        return this.value === undefined && !this.isFinished && !this.isError;
    }
    isTemplate(value) {
        return value instanceof TemplateRef;
    }
}
ProgressBar.ɵfac = function ProgressBar_Factory(t) { return new (t || ProgressBar)(); };
ProgressBar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ProgressBar, selectors: [["ibm-progress-bar"]], hostVars: 18, hostBindings: function ProgressBar_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("bx--progress-bar", ctx.defaultClass)("bx--progress-bar--big", ctx.bigBar)("bx--progress-bar--small", ctx.smallBar)("bx--progress-bar--default", ctx.defaultType)("bx--progress-bar--indented", ctx.indentedType)("bx--progress-bar--inline", ctx.inlineType)("bx--progress-bar--finished", ctx.isFinished)("bx--progress-bar--error", ctx.isError)("bx--progress-bar--indeterminate", ctx.indeterminate);
    } }, inputs: { id: "id", max: "max", type: "type", status: "status", size: "size", value: "value", label: "label", helperText: "helperText" }, decls: 4, vars: 11, consts: [["class", "bx--progress-bar__label", 3, "id", 4, "ngIf"], ["role", "progressbar", 1, "bx--progress-bar__track"], [1, "bx--progress-bar__bar", 3, "ngStyle"], ["class", "bx--progress-bar__helper-text", 3, "id", 4, "ngIf"], [1, "bx--progress-bar__label", 3, "id"], [1, "bx--progress-bar__label-text"], [4, "ngIf"], ["fill", "currentColor", "ibmIcon", "checkmark--filled", "class", "bx--progress-bar__status-icon", 4, "ngIf"], ["fill", "currentColor", "ibmIcon", "error--filled", "class", "bx--progress-bar__status-icon", 4, "ngIf"], [3, "ngTemplateOutlet"], ["fill", "currentColor", "ibmIcon", "checkmark--filled", 1, "bx--progress-bar__status-icon"], ["fill", "currentColor", "ibmIcon", "error--filled", 1, "bx--progress-bar__status-icon"], [1, "bx--progress-bar__helper-text", 3, "id"]], template: function ProgressBar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ProgressBar_div_0_Template, 6, 5, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, ProgressBar_div_3_Template, 3, 3, "div", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-invalid", ctx.isError)("labelledby", ctx.id)("describedby", ctx.helperText ? ctx.helperId : null)("aria-valuemin", !ctx.indeterminate ? 0 : null)("aria-valuemax", !ctx.indeterminate ? ctx.max : null)("aria-valuenow", !ctx.indeterminate ? ctx.value : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(9, _c0, !ctx.isFinished && !ctx.isError ? ctx.percentage : null));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helperText);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgStyle, ɵngcc2.IconDirective], encapsulation: 2 });
ProgressBar.progressBarCounter = 0;
ProgressBar.propDecorators = {
    value: [{ type: Input }],
    bigBar: [{ type: HostBinding, args: ["class.bx--progress-bar--big",] }],
    smallBar: [{ type: HostBinding, args: ["class.bx--progress-bar--small",] }],
    defaultType: [{ type: HostBinding, args: ["class.bx--progress-bar--default",] }],
    indentedType: [{ type: HostBinding, args: ["class.bx--progress-bar--indented",] }],
    inlineType: [{ type: HostBinding, args: ["class.bx--progress-bar--inline",] }],
    isFinished: [{ type: HostBinding, args: ["class.bx--progress-bar--finished",] }],
    isError: [{ type: HostBinding, args: ["class.bx--progress-bar--error",] }],
    indeterminate: [{ type: HostBinding, args: ["class.bx--progress-bar--indeterminate",] }],
    id: [{ type: Input }],
    label: [{ type: Input }],
    helperText: [{ type: Input }],
    max: [{ type: Input }],
    type: [{ type: Input }],
    status: [{ type: Input }],
    size: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ["class.bx--progress-bar",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressBar, [{
        type: Component,
        args: [{
                selector: "ibm-progress-bar",
                template: `
		<div
			*ngIf="label"
			class="bx--progress-bar__label"
			[id]="id">
			<span class="bx--progress-bar__label-text">
				<ng-container *ngIf="!isTemplate(label)">{{label}}</ng-container>
				<ng-template *ngIf="isTemplate(label)" [ngTemplateOutlet]="label"></ng-template>
			</span>
			<svg
				*ngIf="isFinished"
				fill="currentColor"
				ibmIcon="checkmark--filled"
				class="bx--progress-bar__status-icon">
			</svg>
			<svg
				*ngIf="isError"
				fill="currentColor"
				ibmIcon="error--filled"
				class="bx--progress-bar__status-icon">
			</svg>
		</div>
		<div
			class="bx--progress-bar__track"
			role="progressbar"
			[attr.aria-invalid]="isError"
			[attr.labelledby]="id"
			[attr.describedby]="helperText ? helperId: null"
			[attr.aria-valuemin]="!indeterminate ? 0 : null"
			[attr.aria-valuemax]="!indeterminate ? max : null"
			[attr.aria-valuenow]="!indeterminate ? value : null">
			<div
				class="bx--progress-bar__bar"
				[ngStyle]="{
					'transform': !isFinished && !isError ? percentage : null
				}">
			</div>
		</div>
		<div
			[id]="helperId"
			*ngIf="helperText"
			class="bx--progress-bar__helper-text">
			<ng-container *ngIf="!isTemplate(helperText)">{{helperText}}</ng-container>
			<ng-template *ngIf="isTemplate(helperText)" [ngTemplateOutlet]="helperText"></ng-template>
		</div>
	`
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], max: [{
            type: Input
        }], type: [{
            type: Input
        }], status: [{
            type: Input
        }], size: [{
            type: Input
        }], defaultClass: [{
            type: HostBinding,
            args: ["class.bx--progress-bar"]
        }], value: [{
            type: Input
        }], bigBar: [{
            type: HostBinding,
            args: ["class.bx--progress-bar--big"]
        }], smallBar: [{
            type: HostBinding,
            args: ["class.bx--progress-bar--small"]
        }], defaultType: [{
            type: HostBinding,
            args: ["class.bx--progress-bar--default"]
        }], indentedType: [{
            type: HostBinding,
            args: ["class.bx--progress-bar--indented"]
        }], inlineType: [{
            type: HostBinding,
            args: ["class.bx--progress-bar--inline"]
        }], isFinished: [{
            type: HostBinding,
            args: ["class.bx--progress-bar--finished"]
        }], isError: [{
            type: HostBinding,
            args: ["class.bx--progress-bar--error"]
        }], indeterminate: [{
            type: HostBinding,
            args: ["class.bx--progress-bar--indeterminate"]
        }], label: [{
            type: Input
        }], helperText: [{
            type: Input
        }] }); })();

class ProgressBarModule {
}
ProgressBarModule.ɵfac = function ProgressBarModule_Factory(t) { return new (t || ProgressBarModule)(); };
ProgressBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ProgressBarModule });
ProgressBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        IconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressBarModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ProgressBar
                ],
                exports: [
                    ProgressBar
                ],
                imports: [
                    CommonModule,
                    IconModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ProgressBarModule, { declarations: function () { return [ProgressBar]; }, imports: function () { return [CommonModule,
        IconModule]; }, exports: function () { return [ProgressBar]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ProgressBar, ProgressBarModule };

